<ul class="nav nav-tabs">
  <div class="d-flex">
    @for (item of uiTabs | keyvalue; track $index) {
      <li class="nav-item" (click)="changeTab(item.value)">
        <a class="nav-link" [class.active]="activeTab === item.value">{{
          item.value
        }}</a>
      </li>
    }
  </div>
</ul>
<div class="tab-content">
  @if (activeTab === uiTabs.tab1) {
    <div class="tab-pane" [ngClass]="activeTab === uiTabs.tab1 ? 'active' : ''">
      <gtapp-user-welfare></gtapp-user-welfare>
    </div>
  }
  @if (activeTab === uiTabs.tab2) {
    <div class="tab-pane" [ngClass]="activeTab === uiTabs.tab2 ? 'active' : ''">
      <div class="mt-2">
        @if (newEventsAvailable) {
          <div class="alert text-primary text-end">
            Refresh page to get latest updates !!!
          </div>
        }
        @if (largeView) {
          <gtapp-gt-table
            [desktopTableBackendData]="missedWelfareData"
            [desktopTableDetails]="tableDetailMissedWelfareCheck"
            [otherParams]="otherParamsMissedWelfareCheck"
            (searchColumn)="searchColumnMissedWelfareCheck($event)"
            (sortColumn)="sortColumnMissedWelfareCheck($event)"
            (paginationChange)="onChangePaginationMissedWelfareCheck($event)"
            (rowClick)="openUserDetailTemplate($event)"
          >
          </gtapp-gt-table>
        } @else {
          <gtapp-card-list
            [mobileCardBackendData]="missedWelfareData"
            [mobileCardDetails]="mobileDetailMissedWelfareCheck"
            [otherParams]="otherParamsMissedWelfareCheck"
            (searchColumn)="searchColumnMissedWelfareCheck($event)"
            (sortColumn)="sortColumnMissedWelfareCheck($event)"
            (paginationChange)="onChangePaginationMissedWelfareCheck($event)"
            (rowClick)="openUserDetailTemplate($event)"
          ></gtapp-card-list>
        }
      </div>
    </div>
  }
  @if (activeTab === uiTabs.tab3) {
    <div class="tab-pane" [ngClass]="activeTab === uiTabs.tab3 ? 'active' : ''">
      <gtapp-sos-alerts></gtapp-sos-alerts>
    </div>
  }
</div>
